type ServiceWorkerUpdateDetail = {
  applyUpdate: () => void;
};

export type ServiceWorkerUpdateEvent = CustomEvent<ServiceWorkerUpdateDetail>;

export const MEDOPILOT_SW_UPDATE_EVENT = "medopilot:sw-update-available";

function emitUpdateAvailable(registration: ServiceWorkerRegistration) {
  const waitingWorker = registration.waiting;
  if (!waitingWorker) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<ServiceWorkerUpdateDetail>(MEDOPILOT_SW_UPDATE_EVENT, {
      detail: {
        applyUpdate: () => waitingWorker.postMessage({ type: "MEDOPILOT_SKIP_WAITING" }),
      },
    }),
  );
}

export function registerServiceWorker() {
  if (import.meta.env.DEV || !("serviceWorker" in navigator)) {
    return;
  }

  let applyingUpdate = false;

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").then((registration) => {
      emitUpdateAvailable(registration);

      registration.addEventListener("updatefound", () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }

        installingWorker.addEventListener("statechange", () => {
          if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
            emitUpdateAvailable(registration);
          }
        });
      });
    });
  });

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!applyingUpdate) {
      return;
    }
    window.location.reload();
  });

  window.addEventListener(MEDOPILOT_SW_UPDATE_EVENT, ((event: ServiceWorkerUpdateEvent) => {
    const originalApplyUpdate = event.detail.applyUpdate;
    event.detail.applyUpdate = () => {
      applyingUpdate = true;
      originalApplyUpdate();
    };
  }) as EventListener);
}
